import React from 'react';
import { Star, User, CheckCircle2 } from 'lucide-react';
const reviews = [{
  name: 'Marta K.',
  role: 'Nauczyciel WF — Warszawa',
  quote: 'W końcu coś, co naprawdę działa w praktyce. W pierwszym tygodniu znalazłam 3 błędy w mojej metodzie nauczania, których wcześniej nigdy nie zauważałam.',
  color: 'bg-blue-500'
}, {
  name: 'Tomasz S.',
  role: 'Trener U14 — Kraków',
  quote: 'Skróciłem czas przygotowania o 80% w pierwszym miesiącu. Nie mogłem uwierzyć, że PDF może tyle zmienić.',
  color: 'bg-green-500'
}, {
  name: 'Piotr W.',
  role: 'Trener U16 — Gdańsk',
  quote: 'W końcu jestem wolny od wymyślania nowego planu co tydzień. Ten system naprawdę działa.',
  color: 'bg-purple-500'
}];
export function TopReviews() {
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-329">
      <div className="max-w-6xl mx-auto" data-id="element-330">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-331">
          Ponad 1 200 nauczycieli nam zaufało
        </h2>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-332">
          {reviews.map((review, index) => <div key={index} className="bg-[#1A3257] rounded-2xl p-5 md:p-6 shadow-lg flex flex-col h-full border-l-4 border-y border-r border-[#1E3A5F]" style={{
          borderLeftColor: '#2ECC71'
        }} data-id="element-333">
              <div className="flex gap-1 mb-3" data-id="element-334">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5" style={{
              fill: '#FFD700',
              color: '#FFD700'
            }} data-id="element-335" />)}
              </div>

              <div className="inline-flex items-center gap-1.5 self-start px-2.5 py-1 rounded-full text-xs font-semibold mb-4" style={{
            background: 'rgba(46, 204, 113, 0.12)',
            color: '#2ECC71'
          }} data-id="element-336">
                <CheckCircle2 className="w-3.5 h-3.5" data-id="element-337" />
                Kupujący potwierdzony
              </div>

              <div className="flex items-start gap-3 md:gap-4 mb-4" data-id="element-338">
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${review.color} flex items-center justify-center flex-shrink-0`} data-id="element-339">
                  <User className="w-5 h-5 md:w-6 md:h-6 text-white" data-id="element-340" />
                </div>
                <div data-id="element-341">
                  <h3 className="font-bold text-white text-sm md:text-base" data-id="element-342">
                    {review.name}
                  </h3>
                  <p className="text-xs md:text-sm text-[#9BA3B5]" data-id="element-343">
                    {review.role}
                  </p>
                </div>
              </div>

              <p className="text-sm md:text-base text-[#E8EAF0] leading-relaxed flex-grow" data-id="element-344">
                "{review.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}